"use strict";
// THIS FILE IS AUTOCODED - DO NOT CHANGE
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LMSSImportFileHeadings = void 0;
const DataType_1 = __importDefault(require("../DataType"));
exports.LMSSImportFileHeadings = {
    [DataType_1.default.ASSET]: [
        "ID",
        "TITLE",
        "DESCRIPTION",
    ],
    [DataType_1.default.POSITION]: [
        "ID",
        "TEAM",
        "TEAMID",
        "TEAMTITLE",
        "TEAM.ID",
        "TEAM.TITLE",
        "TITLE",
    ],
    [DataType_1.default.PLACE]: [
        "ID",
        "TITLE",
        "TAGS",
        "TIMEZONE",
    ],
    [DataType_1.default.STAFF]: [
        "ID",
        "TITLE",
        "EMAIL",
        "TEL",
        "PLACES",
        "PLACESID",
        "PLACESTITLE",
        "PLACES.ID",
        "PLACES.TITLE",
        "POSITIONS",
        "POSITIONSID",
        "POSITIONSTITLE",
        "POSITIONS.ID",
        "POSITIONS.TITLE",
    ],
    [DataType_1.default.TEAM]: [
        "ID",
        "TITLE",
        "POSITIONS",
        "POSITIONSID",
        "POSITIONSTITLE",
        "POSITIONS.ID",
        "POSITIONS.TITLE",
    ],
};
exports.default = exports.LMSSImportFileHeadings;
